import {useEffect} from 'react';

export type KeyType =
  | 'Enter'
  | 'ArrowDown'
  | 'ArrowUp'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'Backspace'
  | 'Delete'
  | 'Tab'
  | 'Escape'
  | 'Shift'
  | 'Control'
  | 'Alt'
  | 'Meta'
  | ' '
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | 'a'
  | 'b'
  | 'c'
  | 'd'
  | 'e'
  | 'f'
  | 'g'
  | 'h'
  | 'i'
  | 'j'
  | 'k'
  | 'l'
  | 'm'
  | 'n'
  | 'o'
  | 'p'
  | 'q'
  | 'r'
  | 's'
  | 't'
  | 'u'
  | 'v'
  | 'w'
  | 'x'
  | 'y'
  | 'z'
  | ','
  | '.'
  | '/'
  | ';'
  | "'"
  | '['
  | ']'
  | '-'
  | '='
  | '`'
  | '\\'
  | '#'
  | 'F1'
  | 'F2'
  | 'F3'
  | 'F4'
  | 'F5'
  | 'F6'
  | 'F7'
  | 'F8'
  | 'F9'
  | 'F10'
  | 'F11'
  | 'F12';

export function useKeyPress(keys: KeyType | KeyType[], handler: (event: KeyboardEvent) => void) {
  useEffect(
    function subscribeToKeyDown() {
      const onKeyDown = (event: KeyboardEvent) => {
        const list: string[] = Array.isArray(keys) ? keys : [keys];
        if (list.includes(event.key)) {
          event.preventDefault();
          handler(event);
        }
      };
      document.addEventListener('keydown', onKeyDown);
      return () => {
        document.removeEventListener('keydown', onKeyDown);
      };
    },
    [keys, handler]
  );
}
